"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const to = (promise) => {
    // eslint-disable-next-line no-prototype-builtins
    if (!promise || !Promise.prototype.isPrototypeOf(promise)) {
        return new Promise((resolve, reject) => {
            reject(new Error('requires promises as the param'));
        }).catch(err => {
            return [err, null];
        });
    }
    return promise
        .then(function (...args) {
        return [null, ...args];
    })
        .catch(err => {
        return [err];
    });
};
exports.default = to;
